(function () {
  if (window.__tpProductCardRowAlignInit) return;
  window.__tpProductCardRowAlignInit = true;

  const CARD_SELECTOR = 'card-product.product-card';
  const CONTAINER_SELECTOR =
    '.products-list, .featured-collection__items, .products-grid-wrap, .f-grid, grid-list';
  const GRID_ITEM_SELECTOR = '.f-column, .swiper-slide';
  const SLOTS = ['title', 'price', 'swatches'];
  const CSS_FIXED_SLOTS = ['desc', 'reviews'];
  const ROW_TOLERANCE = 8;

  let isAligning = false;

  function debounce(fn, wait) {
    let timer;
    return function debounced() {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  const debouncedAlignAll = debounce(alignAll, 150);

  function isRowAlignDisabled(container) {
    if (!container) return false;
    const mode = container.getAttribute('data-pcard-row-align');
    if (mode === 'off' || mode === 'css') return true;
    if (container.closest('[data-pcard-row-align="off"], [data-pcard-row-align="css"]')) return true;
    if (container.closest('.section--product-tabs')) return true;
    if (container.classList.contains('swiper-wrapper')) return true;
    if (container.closest('.swiper-wrapper, .swiper, featured-collection[data-enable-slider="true"]')) {
      return true;
    }
    return false;
  }

  function shouldObserveContainer(container) {
    if (!container) return false;
    if (isRowAlignDisabled(container)) return false;
    if (container.closest('featured-collection[data-enable-slider="true"]')) return false;
    return true;
  }

  function isAlignableCard(card) {
    if (!card || card.offsetParent === null) return false;
    const slide = card.closest('.swiper-slide');
    if (slide && slide.classList.contains('swiper-slide-duplicate')) return false;
    return true;
  }

  function getGridItem(card) {
    return card.closest(GRID_ITEM_SELECTOR) || card;
  }

  function getRowTop(card) {
    return Math.round(getGridItem(card).getBoundingClientRect().top);
  }

  function getRowLeft(card) {
    return Math.round(getGridItem(card).getBoundingClientRect().left);
  }

  function getContainers() {
    const containers = new Set();
    document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      if (!isAlignableCard(card)) return;
      const container = card.closest(CONTAINER_SELECTOR);
      if (!container || isRowAlignDisabled(container)) return;
      containers.add(container);
    });
    return containers;
  }

  function getSlotElement(card, slot) {
    return card.querySelector('[data-pcard-row-slot="' + slot + '"]');
  }

  function resetCard(card) {
    SLOTS.concat(CSS_FIXED_SLOTS).forEach((slot) => {
      const el = getSlotElement(card, slot);
      if (el) el.style.minHeight = '';
    });

    const placeholder = card.querySelector('.product-card__swatches-placeholder');
    if (placeholder) {
      placeholder.classList.remove('is-row-active', 'is-row-hidden');
      placeholder.hidden = false;
    }
  }

  function groupCardsByRow(cards) {
    const sorted = cards
      .map((card) => ({ card, top: getRowTop(card), left: getRowLeft(card) }))
      .sort((a, b) => a.top - b.top || a.left - b.left);

    const rows = [];
    sorted.forEach(({ card, top }) => {
      const row = rows.find((entry) => Math.abs(entry.top - top) <= ROW_TOLERANCE);
      if (row) {
        row.cards.push(card);
      } else {
        rows.push({ top, cards: [card] });
      }
    });

    return rows.map((entry) => entry.cards);
  }

  function hasRealSwatches(card) {
    const container = card.querySelector(
      '[data-pcard-row-slot="swatches"]:not(.product-card__swatches-placeholder)'
    );
    return Boolean(container && container.querySelector('.swatches--product-card, .swatches'));
  }

  function rowHasSwatches(cards) {
    return cards.some(hasRealSwatches);
  }

  function isMeasurableSlot(slot, el) {
    return true;
  }

  function measureHeight(el) {
    return Math.ceil(el.getBoundingClientRect().height);
  }

  function alignSlot(cards, slot, rowContext) {
    const elements = cards
      .map((card) => getSlotElement(card, slot))
      .filter(Boolean)
      .filter((el) => {
        if (el.hidden || el.classList.contains('is-row-hidden')) return false;
        if (
          slot === 'swatches' &&
          el.classList.contains('product-card__swatches-placeholder') &&
          !el.classList.contains('is-row-active')
        ) {
          return false;
        }
        return true;
      });

    if (!elements.length) return;

    if (slot === 'swatches' && !rowContext.hasSwatches) {
      elements.forEach((el) => {
        el.style.minHeight = '';
      });
      return;
    }

    elements.forEach((el) => {
      el.style.minHeight = '';
    });

    const measurable = elements.filter((el) => isMeasurableSlot(slot, el));
    const heightSource = measurable.length ? measurable : elements;
    let maxHeight = Math.max(...heightSource.map(measureHeight));

    if (maxHeight <= 0) return;

    elements.forEach((el) => {
      el.style.minHeight = maxHeight + 'px';
    });
  }

  function alignRow(cards) {
    const hasSwatches = rowHasSwatches(cards);

    cards.forEach((card) => {
      const placeholder = card.querySelector('.product-card__swatches-placeholder');
      if (!placeholder) return;
      placeholder.classList.toggle('is-row-active', hasSwatches);
      placeholder.classList.toggle('is-row-hidden', !hasSwatches);
      placeholder.hidden = !hasSwatches;
    });

    SLOTS.forEach((slot) => {
      cards.forEach((card) => {
        const el = getSlotElement(card, slot);
        if (el) el.style.minHeight = '';
      });
    });

    if (cards[0]) void cards[0].offsetHeight;

    const rowContext = { hasSwatches };
    SLOTS.forEach((slot) => alignSlot(cards, slot, rowContext));
  }

  function clearContainerAlign(container) {
    container.querySelectorAll(CARD_SELECTOR).forEach(resetCard);
  }

  function alignContainer(container) {
    if (!container || isRowAlignDisabled(container)) return;

    const cards = [...container.querySelectorAll(CARD_SELECTOR)].filter(isAlignableCard);
    if (cards.length < 2) return;

    cards.forEach(resetCard);
    groupCardsByRow(cards).forEach(alignRow);
  }

  function alignAll() {
    if (isAligning) return;
    isAligning = true;
    try {
      getContainers().forEach(alignContainer);
    } finally {
      isAligning = false;
    }
  }

  function observeContainer(container) {
    if (container.__tpPcardRowAlignObserved) return;
    if (!shouldObserveContainer(container)) return;
    container.__tpPcardRowAlignObserved = true;

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(debounce(alignAll, 120));
      ro.observe(container);
    }
  }

  function initObservers() {
    getContainers().forEach(observeContainer);

    const productGrid = document.getElementById('ProductGridContainer');
    if (productGrid && !productGrid.__tpPcardRowAlignObserved) {
      productGrid.__tpPcardRowAlignObserved = true;
      if ('MutationObserver' in window) {
        const gridMo = new MutationObserver(debounce(alignAll, 150));
        gridMo.observe(productGrid, { childList: true, subtree: true });
      }
    }

    if ('MutationObserver' in document.body) {
      const mo = new MutationObserver(
        debounce((mutations) => {
          const shouldAlign = mutations.some((mutation) => {
            const target = mutation.target;
            if (!(target instanceof Element)) return false;
            if (target.closest('featured-collection[data-enable-slider="true"]')) {
              return false;
            }
            if (
              target.closest(
                '.jdgm-widget, .jdgm-preview-badge, .jdgm-prev-badge, [data-pcard-row-slot="reviews"]'
              )
            ) {
              return false;
            }
            return Boolean(target.closest('[data-pcard-row-slot="desc"]'));
          });
          if (shouldAlign) debouncedAlignAll();
        }, 200)
      );
      mo.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  window.TPProductCardRowAlign = {
    refresh: alignAll,
  };

  const run = () => {
    initObservers();
    requestAnimationFrame(alignAll);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', debouncedAlignAll);
  window.addEventListener('resize', debouncedAlignAll);
  document.addEventListener('shopify:section:load', () => {
    setTimeout(alignAll, 120);
  });
  document.addEventListener('tabChange', () => {
    document
      .querySelectorAll('.products-list[data-pcard-row-align="off"]')
      .forEach(clearContainerAlign);
  });

  [800, 2000].forEach((delay) => {
    setTimeout(debouncedAlignAll, delay);
  });
})();
